import tebogoPortrait from '../assets/images/profile/Tebogo_Kole-pic-2.jpeg';
import tebogoOutdoor from '../assets/images/profile/Tebogo_Kole-pic.jpg';

/**
 * Presenter photos shipped with the website. A webinar refers to one by its key (chosen in the
 * dashboard's webinar form, saved as presenterPhoto). To add a presenter: put the photo in
 * src/assets/images/profile/, import it above and add a key here; it then appears in the form.
 */
export const PRESENTER_PHOTOS: Record<string, string> = {
  "tebogo-kole": tebogoPortrait,
  "tebogo-kole-outdoor": tebogoOutdoor,
};

export const presenterPhotoUrl = (key?: string) => (key ? PRESENTER_PHOTOS[key] : undefined);
